import { Button } from '@silospot/ui';
import type { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage(): ReactElement {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-background p-4 text-center">
      <p className="text-5xl font-bold text-primary">404</p>
      <p className="text-muted-foreground">This page could not be found.</p>
      <Button onClick={() => navigate('/dashboard')}>Go to dashboard</Button>
    </div>
  );
}
